import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import {
  FaInstagram,
  FaLinkedinIn,
  FaTelegram,
  FaTiktok,
  FaTumblr,
  FaYoutube,
} from "react-icons/fa";
import { FaThreads, FaXTwitter } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useDisconnect, useAccount } from "wagmi";
import GoogleTranslate from "../../Pages/GoogleTranslate";
import '../css/newfooter.css'
import config from "../../../config";

export default function NewFooter() {
  const navigate = useNavigate();
  const { address, isConnected } = useAccount();
  //let loginDetails = useSelector((state) => state.auth.LoginDetails);

  // const applicationForm = () => {
  //   if (!isConnected) {
  //     toast.error("Please connect your wallet.");
  //     return;
  //   }
  //   navigate(`${config.baseUrl}launchprocessform`);
  //   window.scrollTo(0, 0);
  // };

  // const liquidityApplicationForm = () => {
  //   if (!isConnected) {
  //     toast.error("Please connect your wallet.");
  //     return;
  //   }
  //   navigate(`${config.baseUrl}liquidityListingForm`);
  //   window.scrollTo(0, 0);
  // };

  // const infiApplicationForm = () => {
  //   if (!isConnected) {
  //     toast.error("Please connect your wallet.");
  //     return;
  //   }
  //   navigate(`${config.baseUrl}infiListingForm`);
  //   window.scrollTo(0, 0);
  // };

  const goTo = (e) => {
    e.preventDefault();
    navigate(`${config.baseurl}`);
    window.scrollTo(0, 0);
  };

  return (
    <>
    <div className="newfooter">
      <section className="py-5 footer bg-white">
        <Container>
          <Row>
            <Col lg={3}>
              <div className="logo mt-3">
                <div>
                  <img
                    src={`assets/images/logo/logo.svg`}
                    alt=""
                    className="img-fluid"
                    onClick={(e) => goTo(e)}
                    width={220}
                  />
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <p className="fs-6 mt-3 mt-md-0 text-center text-md-start text-dark-grey">
                The INFI CDEX MultiChain Exchange operates as a cutting-edge
                cryptocurrency trading platform, governed by the proprietary
                ©SbSe protocol. This platform prioritizes robust cybersecurity,
                transparency, and cost-effective trading solutions.
                Additionally, it enables users to earn transaction rewards in
                stablecoins, along with passive income distributed monthly in
                USDT and Bitcoin.
              </p>
            </Col>

            <Col lg={3}>
              <div className="text-center text-md-end icons">
              <span className="me-2">
                  <a
                    href="https://www.linkedin.com/showcase/infi-multichain-cdex/?viewAsMember=true"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <span className="fs-5">
                      <FaLinkedinIn />
                    </span>
                  </a>
                </span>
                <span className="me-2">
                  <a
                    href="https://www.youtube.com/@INFIMultiChainCDEX"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <span className="fs-5">
                      <FaYoutube />
                    </span>
                  </a>
                </span>
                <span className="me-2">
                  <a href="https://x.com/INFI_MultiChain" 
                  target="_blank"
                  rel="noreferrer noopener"
                  >
                    <FaXTwitter />
                  </a>
                </span>
                <span className="me-2">
                  <a href="https://www.tiktok.com/@infimultichain8?_t=ZN-8uGNQNTIXsU&_r=1" 
                  target="_blank"
                  rel="noreferrer noopener"
                  >
                    <FaTiktok />
                  </a>
                </span>
                <span className="me-2">
                  <a href="https://www.instagram.com/inverted_investment/?igsh=aXdreXhvamRkbWVk" 
                  target="_blank"
                  rel="noreferrer noopener"
                  >
                    <FaInstagram />
                  </a>
                </span>
                <span className="me-2">
                  <a href="https://www.threads.net/@inverted_investment" 
                  target="_blank"
                  rel="noreferrer noopener"
                  >
                    <FaThreads />
                  </a>
                </span>
                <span className="me-2">
                  <a href="https://www.tumblr.com/infimultichain?source=share" 
                  target="_blank"
                  rel="noreferrer noopener"
                  >
                    <FaTumblr />
                  </a>
                </span>
                <span className="mx-1">
                  <a
                    href="https://t.me/InvertedInvestmentOfficialGroup"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <FaTelegram />
                  </a>
                </span>
              </div>
            </Col>
          </Row>

          <div className="footer_section mt-5">
            <div>
              <ul className="d-lg-flex justify-content-between list-unstyled">
                <li className="footer-widget">
                  <div className="footer-block">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <h5 style={{fontWeight: "bold"}}>General </h5>
                      </li>
                      <li className="mb-2">
                        <a href="https://launchpad.infimultichain.com/about"target="_blank" rel="noreferrer noopener">About Us</a>
                      </li>
                      <li className="mb-2">
                        <a href="https://launchpad.infimultichain.com/platformInsight" target="_blank" rel="noreferrer noopener">Platform Insights{" "}
                        </a>
                      </li>
                      <li className="mb-2">
                        <a href="https://launchpad.infimultichain.com/termscondition" target="_blank" rel="noreferrer noopener">Terms Of Use {" "}
                        </a>
                      </li>
                      <li className="mb-2">
                        <a href="https://launchpad.infimultichain.com/privacypolicy" target="_blank" rel="noreferrer noopener">Privacy Policy</a>
                      </li>
                      <li className="mb-2">
                        <a href="https://www.trustpilot.com/review/infimultichain.com" target="_blank" rel="noreferrer noopener">Feedback</a>
                      </li>
                      {/* <li className="mb-2">
                        <a href={`${config.baseUrl}tradingfees`} target="_blank" rel="noreferrer noopener">Trading Fees</a>
                      </li> */}
                      <li className="mb-2">
                        <a href="https://infimultichain.com/ico/blog" target="_blank" rel="noreferrer noopener">Blog</a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="footer-widget">
                  <div className="footer-block">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <h5 style={{fontWeight: "bold"}}>Help </h5>
                      </li>
                      <li className="mb-2">
                        <a href="https://launchpad.infimultichain.com/contact" target="_blank" rel="noreferrer noopener">Contact Us</a>
                      </li>
                      <li className="mb-2">
                        <a href="https://launchpad.infimultichain.com/faq" target="_blank" rel="noreferrer noopener">FAQs</a>
                      </li>
                      <li className="mb-2">
                        <a href="mailto:support@infimultichain.com">support@infimultichain.com</a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="footer-widget">
                  <div className="footer-block">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <h5 style={{fontWeight: "bold"}}>Languages</h5>
                      </li>
                      <GoogleTranslate/>
                      {/* <li className="mb-2">
                        <a href="#">
                          <div className="d-flex align-items-center gap-2 ">
                            <img
                              src="images/flagIcon/unitedstates.svg"
                              width={`16px`}
                            />
                            English
                          </div>
                        </a>
                      </li>
                      <li className="mb-2">
                        <a href="#">
                          <div className="d-flex align-items-center gap-2 ">
                            <img
                              src="images/flagIcon/russia.svg"
                              width={`16px`}
                            />
                            Russian
                          </div>
                        </a>
                      </li>
                      <li className="mb-2">
                        <a href="#">
                        <img
                          <div className="d-flex align-items-center gap-2 ">
                              src="images/flagIcon/china.svg"
                              width={`16px`}
                            />
                            Chinese
                          </div>
                        </a>
                      </li>
                      <li className="mb-2">
                        <a href="#">
                          <div className="d-flex align-items-center gap-2 ">
                            <img
                              src="images/flagIcon/turkey.svg"
                              width={`16px`}
                            />
                            Turkish
                          </div>
                        </a>
                      </li>
                      <li className="mb-2">
                        <a href="#">
                          <div className="d-flex align-items-center gap-2 ">
                            <img
                              src="images/flagIcon/korea.svg"
                              width={`16px`}
                            />
                            Korean
                          </div>
                        </a>
                      </li> */}
                    </ul>
                  </div>
                </li>
                <li className="footer-widget">
                  <div className="footer-block">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <h5 style={{fontWeight: "bold"}}>Token</h5>
                      </li>
                      <li className="mb-2">
                        <a href="#">
                          <div className="d-flex align-items-center gap-2 ">
                            <img
                              src="assets/images/FooterLogos/icon/coingecko.svg"
                              width={`16px`}
                              alt=""
                            />
                            CoinGeko{" "}
                            <span className="text-primary">(Soon)</span>
                          </div>
                        </a>
                      </li>
                      <li className="mb-2">
                        <a href="#">
                          <div className="d-flex align-items-center gap-2 ">
                            <img
                              src="assets/images/FooterLogos/icon/coinmarketcap.svg"
                              width={`16px`}
                              alt=""
                            />
                            CoinMarketCap{" "}
                            <span className="text-primary">(Soon)</span>
                          </div>
                        </a>
                      </li>
                      <li className="mb-2">
                        <a href="https://infimultichain.com/">
                          <div className="d-flex align-items-center gap-2 ">
                            <img
                              src="assets/images/FooterLogos/icon/infi.png"
                              width={`16px`}
                              alt=""
                            />
                            INFI Multichain CDEX
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="footer-widget">
                  <div className="footer-block">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <h5 style={{fontWeight: "bold"}}>Audits</h5>
                      </li>
                      <li className="mb-2">
                        <div>
                          <a href="https://app.solidproof.io/projects/inverted-investment" target="_blank" rel="noreferrer noopener">
                            <img src="assets/images/FooterLogos/solidproof.png" 
                            alt=""/>
                          </a>
                        </div>
                        <div className="text-lg-end">
                          <small>
                            Protected by <span>Cyvers</span>{" "}
                            <img src="assets/images/FooterLogos/cyverse.png" alt=""/>
                          </small>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <hr className="my-4" />

          <div className="d-block d-lg-flex justify-content-between">
            <div>
              <a
                href="mailto:support@infimultichain.com"
                className="me-3 text-decoration-none d-inline-block"
              >
                support@infimultichain.com
              </a>
            </div>
            <div className="mt-3 mt-lg-0">
              <a href="javascript:void(0)" className="text-decoration-none" >
                © 2024 INFI Multichain. All rights reserved.
              </a>
            </div>
          </div>
        </Container>
      </section>
      </div>
    </>
  );
}
